export interface CrsGroupInfo {
  name: string;
  description: string;
}

export const CRS_GROUP_INFO: Record<number, CrsGroupInfo> = {
  911: {
    name: "Method Enforcement",
    description:
      "Restricts allowed HTTP methods, blocking unusual verbs used in reconnaissance or exploit delivery.",
  },
  913: {
    name: "Scanner Detection",
    description:
      "Detects known web vulnerability scanners, automated crawlers, and security-testing tools by their request signatures.",
  },
  920: {
    name: "Protocol Enforcement",
    description:
      "Validates HTTP protocol compliance—headers, versions, content lengths—blocking malformed or ambiguous requests.",
  },
  921: {
    name: "Protocol Attack",
    description:
      "Guards against HTTP request smuggling, response splitting, and header injection targeting proxies and intermediaries.",
  },
  922: {
    name: "Multipart Request Limits",
    description:
      "Enforces multipart/form-data upload boundaries to prevent boundary abuse and request-parser confusion.",
  },
  930: {
    name: "Local File Inclusion (LFI)",
    description:
      "Detects path traversal and local file inclusion payloads that attempt to read sensitive files from the server.",
  },
  931: {
    name: "Remote File Inclusion (RFI)",
    description:
      "Blocks attempts to include remote files via URL parameters, which can result in remote code execution.",
  },
  932: {
    name: "Remote Code Execution (RCE)",
    description:
      "Identifies shell command injection and OS command execution patterns in request parameters, headers, and body.",
  },
  933: {
    name: "PHP Injection",
    description:
      "Blocks PHP-specific injection attacks including code execution via PHP functions, wrappers, and configuration directives.",
  },
  934: {
    name: "Node.js Injection",
    description:
      "Detects Node.js-specific injection patterns including prototype pollution and server-side JavaScript injection.",
  },
  941: {
    name: "Cross-Site Scripting (XSS)",
    description:
      "Detects and blocks XSS payloads in all request inputs, including HTML tags, event handlers, and encoded variants.",
  },
  942: {
    name: "SQL Injection",
    description:
      "Protects against SQL injection by detecting SQL keywords, operators, and encoded payloads in request data.",
  },
  943: {
    name: "Session Fixation",
    description:
      "Prevents session fixation attacks by detecting attempts to inject or manipulate session identifiers.",
  },
  944: {
    name: "Java Attacks",
    description:
      "Blocks Java-specific exploit patterns including deserialization gadgets, OGNL injection, and Log4Shell-style payloads.",
  },
};
